import { render, staticRenderFns } from "./DivisionHead.vue?vue&type=template&id=2fdfe222"
import script from "./DivisionHead.vue?vue&type=script&lang=js"
export * from "./DivisionHead.vue?vue&type=script&lang=js"
import style0 from "./DivisionHead.vue?vue&type=style&index=0&id=2fdfe222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports